import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ ...params }) => {
  return await dponetAPI.get(`/data_processes/data_intelligence`, { params })
}

export default {
  get,
}
